import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { shouldNotForwardProps } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2;
const Container = styled(Menu, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _``));
const Content = styled('div')(_t2 || (_t2 = _`
  display: inline;
`));
const Popover = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpen = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  return jsxs(Fragment, {
    children: [jsx(Content, Object.assign({
      onClick: handleOpen
    }, {
      children: props.children
    })), jsx(Container, Object.assign({}, props, {
      anchorEl: anchorEl,
      onClose: handleClose,
      open: open
    }, {
      children: props.items({
        close: handleClose
      })
    }))]
  });
};
const PopoverItem = MenuItem;

export { Popover, PopoverItem };
